/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmailConsentCustomerDto } from '../../models/email-consent-customer-dto';

export interface ApiIdentityEmailconsentGet$Params {
}

export function apiIdentityEmailconsentGet(http: HttpClient, rootUrl: string, params?: ApiIdentityEmailconsentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailConsentCustomerDto>> {
  const rb = new RequestBuilder(rootUrl, apiIdentityEmailconsentGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmailConsentCustomerDto>;
    })
  );
}

apiIdentityEmailconsentGet.PATH = '/api/identity/emailconsent';
